import { WEBSOCKET_URL } from "api";
import { UnAuthenticatedRoutes } from "constants/route";
import { jwtDecode } from "jwt-decode";
import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { useLocation } from "react-router-dom";
import { io, Socket } from "socket.io-client";

interface ISocketIoContextProps {
  socket: Socket | undefined;
  disconnect: () => void;
}

export const SocketIoContext = createContext<ISocketIoContextProps>(
  {} as ISocketIoContextProps
);

export const useSocketIoContext = () =>
  useContext<ISocketIoContextProps>(SocketIoContext);

export function SocketIoContextProvider({ children }: { children: ReactNode }) {
  const location = useLocation();
  const [socket, setSocket] = useState<Socket>();
  useEffect(() => {
    try {
      if (
        socket !== undefined &&
        UnAuthenticatedRoutes.includes(location.pathname)
      ) {
        socket.disconnect();
        setSocket(undefined);
        return;
      } else if (
        socket === undefined &&
        !UnAuthenticatedRoutes.includes(location.pathname)
      ) {
        // Verify token exists and is valid
        const token = localStorage.getItem("token");
        if (!token) throw new Error("No token");
        const payload: any = jwtDecode(token);
        if (payload.role === "casher") return;
        const socketIo = io(WEBSOCKET_URL, {
          autoConnect: true,
          extraHeaders: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        } as any);
        socketIo.connect();
        socketIo.on("connect", onConnect);
        socketIo.on("disconnect", onDisconnect);
        setSocket(socketIo);
      }
    } catch (error) {
      socket?.disconnect();
      setSocket(undefined);
    }
  }, [location.pathname]); // eslint-disable-line

  const onConnect = useCallback(() => {}, []);
  const onDisconnect = useCallback(() => {}, []);

  const handleDisconnect = useCallback(() => {
    socket?.disconnect();
  }, [socket]);

  return (
    <SocketIoContext.Provider value={{ socket, disconnect: handleDisconnect }}>
      {children}
    </SocketIoContext.Provider>
  );
}
